import React from 'react';
import { RouterProvider } from 'react-router';
import '../../css/museum-app.css';
import appRouter from './routes';
// Removed redundant LanguageProvider import
import { SyncProvider } from './store/sync-context';

/**
 * Main App component for the Museum PWA
 * - Provides the SyncContext for offline capabilities
 * - Provides the LanguageContext for multi-language support
 * - Renders the app routes using the RouterProvider
 */
const App: React.FC = () => {
    return (
        <SyncProvider>
            {/* LanguageProvider removed, SettingsProvider handles language */}
            <RouterProvider router={appRouter} />
        </SyncProvider>
    );
};

export default App;
